import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CircularProgress } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useState } from 'react';
import { TextField } from '../text-field';
import { useTheme } from '@mui/material/styles';
import useSuggestAddress from '@hooks/useSuggestAddress';
import { useDebounce } from '@uidotdev/usehooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SearchAddressInput = function SearchAddressInput(_ref) {
  var onChange = _ref.onChange,
    error = _ref.error,
    touched = _ref.touched,
    label = _ref.label,
    value = _ref.value,
    onSelect = _ref.onSelect;
  var theme = useTheme();
  var debouncedAddress = useDebounce(value, 500);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focus = _useState2[0],
    setFocus = _useState2[1];
  var _useSuggestAddress = useSuggestAddress(debouncedAddress),
    suggestions = _useSuggestAddress.data,
    isFetching = _useSuggestAddress.isFetching,
    responseError = _useSuggestAddress.error;
  var handleChange = function handleChange(_, newValue, reason) {
    onChange(newValue);
    setFocus(true);
    if (onSelect && reason === 'reset') {
      onSelect(suggestions === null || suggestions === void 0 ? void 0 : suggestions.find(function (item) {
        return item.value === newValue;
      }));
    }
  };
  var handleClose = function handleClose() {
    setFocus(false);
  };
  var handleFocus = function handleFocus() {
    setFocus(true);
  };
  var hasError = error && touched && responseError;
  return /*#__PURE__*/_jsx(Autocomplete, {
    options: suggestions.map(function (suggestion) {
      return {
        label: suggestion.value,
        value: suggestion.value
      };
    }),
    freeSolo: true,
    open: suggestions.length > 0 && focus,
    onClose: handleClose,
    disablePortal: true,
    onInputChange: handleChange,
    inputValue: value
    // open={suggestions.length > 0}
    ,
    filterOptions: function filterOptions() {
      return suggestions.map(function (suggestion) {
        return {
          label: suggestion.value,
          value: suggestion.value
        };
      });
    },
    defaultValue: {
      label: value,
      value: value
    },
    componentsProps: {
      paper: {
        sx: {
          bgcolor: theme.palette.mirage.dark,
          color: theme.palette.mirage.contrastText
        }
      }
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, params), {}, {
        label: label || 'Search',
        fullWidth: true,
        onFocus: handleFocus,
        autoComplete: "off",
        sx: {
          '& input': {
            height: '34px !important'
          }
        },
        error: hasError,
        helperText: hasError ? error : null,
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          endAdornment: /*#__PURE__*/_jsxs(React.Fragment, {
            children: [isFetching ? /*#__PURE__*/_jsx(CircularProgress, {
              color: "inherit",
              size: 20
            }) : null, params.InputProps.endAdornment]
          })
        })
      }));
    }
  });
};
export default SearchAddressInput;